var _stop, _stop2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgTriangleTop = function SvgTriangleTop(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 42,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id, ")"),
    d: "M33.126.426C21.475 3.05 9.078 5.845 6.977 6.317c-2.1.473-4.715 1.815-6.096 4.931-1.34 3.02-.608 7.11 1.799 8.69 2.406 1.58 29.91 19.492 31.662 20.694 1.751 1.201 5.287 2.064 9.207-.334 3.92-2.399 4.024-5.833 3.758-7.744-.267-1.91-4.278-23.746-4.698-26.077-.42-2.33-1.135-4.14-2.728-5.222-2.024-1.373-3.768-1.501-6.755-.829Z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 45.262,
    x2: 11.829,
    y1: 8.059,
    y2: 32.774,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  })))));
};
export default SvgTriangleTop;